import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
  exAnteHeader: {
    fontSize: 24,
    fontFamily: 'Roboto-Bold',
    margin: 0
  }
}))